import React from 'react';
import { FORM_ELEMENT_TYPES } from '../newFormElement/types';
import { BrowserLocaleDateFormatter } from '../constants/global';
import { isCheckboxChecked } from '../utils/checkboxValue';
import { $Container, $SectionTitle, $SectionHeader, $DataRow, $DataLabel, $DataValue, $DataLink } from './styles';
import { $Text } from '../newTypography';
import { Divider } from '../newDivider';
const formatValues = (values, elementType) => {
    if (!values || values.length === 0 || (values.length === 1 && (values[0] === '')))
        return '';
    if (elementType === FORM_ELEMENT_TYPES.DATE) {
        return values.map((v) => {
            try {
                return BrowserLocaleDateFormatter.format(new Date(v));
            }
            catch {
                return v;
            }
        }).join(', ');
    }
    if (elementType === FORM_ELEMENT_TYPES.CHECKBOX) {
        return values.map((v) => isCheckboxChecked(v) ? 'Yes' : 'No').join(', ');
    }
    if (elementType === FORM_ELEMENT_TYPES.MULTISELECT) {
        return values.join(', ');
    }
    return values.join(' ');
};
export const PreviewFlowElement = ({ title, description, errorMsg, error, items, onUploadClick }) => (React.createElement($Container, null,
    React.createElement($SectionTitle, { error: error || !!errorMsg }, title),
    (description || errorMsg) &&
        React.createElement($Text, null, errorMsg || description),
    (items || []).map((item) => ((item.datas || []).map((data) => {
        const value = formatValues(data.values, data.element_type);
        return (React.createElement("div", { key: data.id },
            (data.groupStart || data.element_type === FORM_ELEMENT_TYPES.GROUP) &&
                React.createElement(Divider, { noMarginBottom: false }),
            data.isSection ? (React.createElement($SectionHeader, { indent: data.indent || 0 }, data.name)) : data.element_type === FORM_ELEMENT_TYPES.UPLOAD && data.values?.[0] ? (React.createElement($DataRow, { indent: data.indent || 0 },
                React.createElement($DataLabel, null, `${data.name}:`),
                React.createElement($DataLink, { onClick: onUploadClick ? (e) => { e.preventDefault(); onUploadClick(data.values[0]); } : undefined, href: onUploadClick ? undefined : data.values[0], target: '_blank', rel: 'noopener noreferrer' }, "View file"))) : (React.createElement($DataRow, { indent: data.indent || 0 },
                React.createElement($DataLabel, { group: data.element_type === FORM_ELEMENT_TYPES.GROUP }, `${data.name}${data.element_type === FORM_ELEMENT_TYPES.GROUP || !value ? '' : ':'}`),
                React.createElement($DataValue, null, value)))));
    })))));
